import { useEffect, useRef, useState } from "react";
import Flex from "../../atom/flex";
import HeaderButton from "./headerButton";
import HeaderDropdownMenu from "./headerDropdownMenu";

const Header = props => {
    const { buttons, dark } = props;

    const [moved, setMoved] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    const mouseInside = useRef(false);

    window.addEventListener("scroll", () => {
        if (window.scrollY >= 60) {
            setMoved(true);
        } else {
            setMoved(false);
        }
    });

    const onHoverHandler = async (activated, key) => {
        if(!isMobile) {
            mouseInside.current = activated ? true : false;
            if(activated) {
                setActiveDropdown(key);
            } else if(activeDropdown === key) {
                await new Promise(r => setTimeout(r, 1000));
                
                if(!mouseInside.current && activeDropdown === key) {
                    setActiveDropdown(null);
                }
            }
        } else {
            if(activated) {
                setActiveDropdown(key);
            } else if(activeDropdown === key) {
                setActiveDropdown(null);
            }
        }
    }

    useEffect(() => {
        if(window.innerWidth < 900) {
            setIsMobile(true);
        }
    }, []);

    return (<>
        <header className={`kt-header ${dark || moved || (activeDropdown !== null) ? "kt-header-solid" : "kt-header-transparent"}`}>
            <Flex
                align="center"
                gap={10}
                style={{
                    height: '100%',
                    padding: '0 10px',
                }}
            >
                <img 
                    src="/img/logo.png"
                    alt="Logo"
                    height={50}
                />
                <label className="kt-header-title">ZYZA</label>
                <Flex.Spacer />
                {isMobile 
                    ? <HeaderDropdownMenu 
                        mobile 
                        data={{ options: buttons }} 
                        onHover={onHoverHandler}
                        activeKey={activeDropdown}
                    />
                    : <Flex gap={20} style={{ width: 'max-content' }}>
                        {buttons.map((row, index) => row.options 
                            ? <HeaderDropdownMenu 
                                key={index} 
                                dropdownKey={index} 
                                activeKey={activeDropdown} 
                                data={row} 
                                onHover={onHoverHandler}
                            />
                            : <HeaderButton 
                                key={index} 
                                href={row.path}
                            >
                                {row.label}
                            </HeaderButton>
                        )}
                    </Flex>
                }
            </Flex>
        </header>
    </>);
};

export default Header;